// The new, streamlined interface (9 October 2026): the weekly. Texts the
// classic screen already had (title, kinds, re-reading) are still read from
// `projector.weekly`.
export default {
  semaine: 'Week of {jour}',
  luLe: 'read on {moment}',
  filtre: 'Filter ideas by kind',
  tout: 'All',
  natures: {
    espace_blanc: 'White spaces',
    emergence: 'Emergences',
    opportunite: 'Opportunities',
    extension: 'Extensions',
  },
  force: {
    forte: 'strong signal',
    moyenne: 'medium signal',
    faible: 'weak signal',
  },
  pourquoiMaintenant: 'Why now.',
  lireLaSuite: 'Read more',
  reduire: 'Show less',
  signaux: 'Signals:',
  aTrancher: 'To decide:',
  poserLaQuestion: 'Ask the question',
  videTexte: 'The weekly reads itself every week. “Read the week” starts it right away.',
}
